<template>
	<div
		v-if="itemsWithQuantity.length > 0"
		class="!py-6 sticky !-mt-10 bottom-0 bg-white border-t-swatch border-solid border-zinc-400 w-[calc(100% + 40px)]"
	>
		<button
			type="button"
			:disabled="loading"
			@click="handleAddToBag"
			class="w-full min-w-40 !px-5 bg-black h-12 justify-center items-center text-white inline-flex !m-0 text-xs/[12px] font-medium uppercase tracking-widest text-center rounded-none disabled:opacity-25 disabled:cursor-not-allowed disabled:pointer-events-none"
		>
			Add Items To Bag
		</button>
	</div>
</template>
<script setup>
import { storeToRefs } from 'pinia'

import { usePaletteBuilderStore } from '@stores'
import { toast } from '@/js/lib/toast.js'

const store = usePaletteBuilderStore()
const { loading, itemsWithQuantity } = storeToRefs(store)
const { addAllToBag } = store

const handleAddToBag = () => addAllToBag(toast)
</script>
